import "./Visit.css";
import React, { useEffect } from "react";
import { Button } from "./Button";

export const Visit = () => {
    useEffect(() => {
        const date = new Date();
        const day = date.getDay();
        const hour = date.getHours();
        const indicate_status = document.getElementById("open_indication");
        if (day >= 1 && day <= 5) {
            if (day === 1 || day === 3 || day === 5) {
                if (hour >= 8 && hour <= 13) {
                    indicate_status.innerHTML = "Gabinet jest teraz otwarty.";
                } else if (hour < 8) {
                    indicate_status.innerHTML =
                        "Gabinet jest jeszcze zamknięty. Otwieramy o 8:00.";
                } else if (hour > 13 && day === 5) {
                    indicate_status.innerHTML =
                        "Gabinet jest już zamknięty. Zadzwoń w poniedziałek od 8:00.";
                } else if (hour > 13 && day !== 5) {
                    indicate_status.innerHTML =
                        "Gabinet jest już zamknięty. Zadzwoń jutro od godziny 12:00.";
                }
            } else if (day === 2 || day === 4) {
                if (hour >= 12 && hour <= 17) {
                    indicate_status.innerHTML = "Gabinet jest teraz otwarty.";
                } else if (hour < 12) {
                    indicate_status.innerHTML =
                        "Gabinet jest jeszcze zamknięty. Otwieramy o 12:00.";
                } else if (hour > 17) {
                    indicate_status.innerHTML =
                        "Gabinet jest już zamknięty. Zadzwoń jutro od godziny 8:00.";
                }
            }
        } else if (day === 6 || day === 0) {
            indicate_status.innerHTML =
                "Gabinet jest dzisiaj zamknięty. Zadzwoń w poniedziałek od godziny 8:00.";
        }
    });

    return (
        <div className="block" id="Call">
            <div className="block_content">
                <h1>
                    Umów się na wizytę{" "}
                    <i className="fa-solid fa-calendar-check"></i>
                </h1>
                <span>
                    Zadzwoń i umów się na wizytę. Zobacz poniżej czy aktualnie
                    pracujemy. Jeżeli nie, możesz zostawić wiadomość e-mail lub
                    zadzwonić następnego dnia.
                </span>
                <Button
                    link="tel:343623401"
                    text="Zadzwoń"
                    icon="fa-solid fa-phone"
                    class="contact button"
                />
                <Button
                    link="mailto:stomatolog@agnieszkapolis.pl"
                    text="Napisz wiadomość"
                    icon="fa-solid fa-envelope"
                    class="contact button"
                />
                <span id="open_indication">
                    Prosimy o kontakt telefoniczny w godzinach pracy gabinetu.
                </span>
            </div>
        </div>
    );
};
